import { render, staticRenderFns } from "./CreatedFileScroll.vue?vue&type=template&id=17a67acc&scoped=true&"
import script from "./CreatedFileScroll.vue?vue&type=script&lang=js&"
export * from "./CreatedFileScroll.vue?vue&type=script&lang=js&"
import style0 from "./CreatedFileScroll.vue?vue&type=style&index=0&id=17a67acc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17a67acc",
  null
  
)

export default component.exports